import React from 'react';
import Footer from './footer';
import Header from './header';
import '../styles/App.scss';
import layoutStyles from './layout.module.scss';

const Layout = (props) => {
  return (
    <div className={`container is-fluid ${layoutStyles.paddingTop0}`}>
      <Header />
      <div style={{ flex: '1' }}>{props.children}</div>
      <Footer />
    </div>
  );
};

export default Layout;
